// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"kL-z","carouselContainer":"lL-z"};